// Delegated so it survives the theme re-rendering the buy-buttons block on variant change.
document.addEventListener('click', (event) => {
  if (!event.target.closest('.mwc-tryon-btn')) return;
  const bound = window.globalTangiblee?.defaultConfig?.cta?._button;
  (bound ?? document.querySelector('.tangiblee-cta'))?.click();
});
